module.exports = __webpack_public_path__ + "img/avatar.8be7fde4.png";